import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ModalController, NavController, PopoverController } from '@ionic/angular';
import { AccountPaymentFavoriteService } from '@wlp/ui-bs-account-payment-favorite';
import { BilletTypeEnum, ChargingService } from '@wlp/ui-bs-cashin';
import { UserInfoService } from '@wlp/ui-bs-login';
import { UiBsTranslateService } from '@wlp/ui-bs-translate';
import * as moment from 'moment';
import { LayoutConfigModel } from 'src/app/core/layout/models/layout-config.model';
import { LayoutConfigService } from 'src/app/core/layout/services/layout-config.service';
import { FavoritesDataFilterPipe } from '../../favorites-data-filter.pipe';
import { LoadingService } from 'src/app/core/layout/services/loading.service';
import { ModalAlertComponent } from 'src/app/views/themes/sentinel/modals/modal-alert/modal-alert.component';
import { ModalBilletViewDetailComponent } from 'src/app/views/themes/sentinel/modals/modal-billet-view-detail/modal-billet-view-detail';
import { UserInfoProfile } from '@wlp/ui-bs-login/lib/dto/user-info-profile';
import { BilletService } from '@wlp/ui-bs-cashin';
import { ModalBilletAlertCancelComponent } from 'src/app/views/themes/sentinel/modals/modal-billet-alert-cancel/modal-billet-alert-cancel';
import { ModalTokenComponent } from 'src/app/views/themes/sentinel/modals/modal-token/modal-token.component';

@Component({
  selector: 'ui-t-billet-view-detail',
  templateUrl: './billet-view-detail.page.html',
  styleUrls: ['./billet-view-detail.page.scss'],
  providers: [FavoritesDataFilterPipe],
})
export class CharginBilletViewDetail implements OnInit {
  idtransaction: string = '53ae2036-be1d-ce0b-c910-d40ccb7f7b04'

  billets: any[] = [];

  moreActionsMenuIsOpen = {
    index: null,
    isOpen: false
  };

  indeterminateState: boolean;
  checkParent: boolean;
  page = 0;
  perPage = 9;
  

  dataBillets = {}
  maskedDataDoc = []
  maskedDataBilletWithdrawn = {}
  dataLotBillets: any[] = [];
  qtdBoletos: any[] = [];

  lotMap = {}
  dataAmount = {}
  dataValue: string = ''
  dataLotListBillets = [];

  public pendingValue: any;
  public pendingQuantity: any;
  public compensatedValue: any;
  public compensatedQuantity: any;
  public canceledValue: any;
  public canceledQuantity: any;
  public errorValue: any;
  public errorQuantity: any;

  public errorMessages: any;
  private langDefault: string;
  private layoutConfigValue: LayoutConfigModel;
  public userProfile: UserInfoProfile;
  private readonly OPERATION: string = '1002';
  public toggleSpinnerUpdate: boolean = false;
  public isItemChecked: boolean = false;
  public allPendingItems = 0;

  constructor(
    public modalController: ModalController,
    public service: ChargingService,
    protected userInfoService: UserInfoService,
    private navCtrl: NavController,
    public accountPaymentFavoriteService: AccountPaymentFavoriteService,
    public router: Router,
    public popoverController: PopoverController,
    public pipeFilter: FavoritesDataFilterPipe,
    private layoutConfigService: LayoutConfigService,
    private translate: UiBsTranslateService,
    private loadingService: LoadingService,
    private billetService: BilletService,
    private cdr: ChangeDetectorRef,
    private route: ActivatedRoute
  ) {
    moment.locale('pt-br');
  }

  ngOnInit(): void {
    this.layoutConfigValue = this.layoutConfigService.getSavedConfig();
    this.langDefault = this.layoutConfigValue.wlTheme.languageDefault;
    this.translate.setDefaultLang(this.langDefault);
    this.getBilletsWithdrawn(this.idtransaction);
    this.loadUser()

    this.pendingValue = 0;
    this.canceledValue = 0;
    this.compensatedValue = 0;
    this.pendingQuantity = 0;
    this.canceledQuantity = 0;
    this.compensatedQuantity = 0;
    
  }

  private loadUser() {
    try {
      const userDetails = this.userInfoService.getInfoProfile();
      userDetails.then((user) => {
        this.userProfile = user;
        this.getBilletsByUuid(user.uuidAccount);
        this.getLotBillets(user.uuidAccount)

      });
    } catch (e) {
      console.error('Failed to load user details', e);
    }
    this.cdr.detectChanges();
  }

  getBilletsWithdrawn(transactionId: string) { 
    this.loadingService.hide(); 
    this.billetService.getBilletsByTransactionId(transactionId)
     .subscribe(
        (res) => {
          this.toggleSpinnerUpdate = false
          this.dataBillets = res;

          Object.entries(this.dataBillets).forEach(([key, value]: [string, string]) => {
            this.maskedDataBilletWithdrawn[key] = value;

            if (key === 'namePayer') {
              let namePayer = value.toLowerCase();
              let formattedName = namePayer.replace(/\b(s\w)/g, firstLetter => firstLetter.toUpperCase());
              this.maskedDataBilletWithdrawn[key] = formattedName;
            }

            let requestDescription = value;
            if (key === 'requestDescription') {
              let formattedDescription = requestDescription.replace(/\b(\w)/g, firstLetter => firstLetter.toUpperCase());
              this.maskedDataBilletWithdrawn[key] = formattedDescription;
            }

            if (key === 'billetDueTime' || key === 'dateRegister') {
              let date = value;
              let day = ('0' + date[2]).slice(-2);
              let month = ('0' + date[1]).slice(-2);
              let formattedDate = day.concat('/', month, '/', date[0]);
              this.maskedDataBilletWithdrawn[key] = formattedDate;
            }

            if (key === 'documentPayer' || key === 'document'  ) {
              let document = value;
              let formatteDocument = document.substring(0, 3) + '.' + document.substring(3, 6) + '.' +
              + document.substring(6, 9) + '-' + document.substring(9, 11);
              this.maskedDataBilletWithdrawn[key] = formatteDocument
            } 
          });
        },
        (err) => {
          this.loadingService.hide();
        },
        () => {
          this.loadingService.hide();
        }
    );
    this.cdr.detectChanges(); 
  }

  getLotBillets(uuidAccount: string) { 
    this.loadingService.hide();
    this.billetService.getLotBillets(uuidAccount)
     .subscribe(
        (res) => {
          this.toggleSpinnerUpdate = false
          this.dataLotBillets = res;

          this.getLotListBillets(uuidAccount, "1176c678-7544-a081-24f5-651fb70c6fcf")
          
          this.getAllStatusDataByUuidAccountPaymentLotBillet('1176c678-7544-a081-24f5-651fb70c6fcf', 'COMPENSATED');
          this.getAllStatusDataByUuidAccountPaymentLotBillet('1176c678-7544-a081-24f5-651fb70c6fcf', 'PENDING');
          this.getAllStatusDataByUuidAccountPaymentLotBillet('1176c678-7544-a081-24f5-651fb70c6fcf', 'CANCELED');

        },
        (err) => {
          console.error(err);
          this.loadingService.hide();
        },
        () => {
          this.loadingService.hide();
        }
    );
    this.cdr.detectChanges();
  }

  getLotListBillets(uuidAccount: string, uuidLotMock: string) {
    this.loadingService.show(); 
    this.billetService.getLotListBillets(uuidAccount, uuidLotMock)
      .subscribe(
      (res) => {
          this.toggleSpinnerUpdate = false     

          res.billets.map(billet => this.billets.push({
            isItemChecked: false,
            ...billet
          }))

          this.lotMap = res.lot 
          
          Object.entries(this.billets[0]).forEach(([key, value]: [string, string]) => {
          // Objeto de Arrays que serve para guarda os dados tratados
          this.maskedDataDoc[key] = value;

          if (key === 'documentPayer') {
            let document = value;
            let formatteDocument = document.substring(0, 3) + '.' + document.substring(3, 6) + '.' +
            + document.substring(6, 9) + '-' + document.substring(9, 11);
            this.maskedDataDoc[key] = formatteDocument
          }    
          });
        }, 
        (err) => {
          console.error(err);
          this.loadingService.hide();
        },
        () => {
          this.loadingService.hide();
        }
    );
    this.cdr.detectChanges();
  } 

  private getAllStatusDataByUuidAccountPaymentLotBillet(uuidAccountPaymentLotBillet: string, status?: string) {
    let type = BilletTypeEnum.CHARGING;
    this.billetService.getAllStatusDataByUuidAccountPaymentLotBillet(this.userProfile.uuidAccount, uuidAccountPaymentLotBillet, type, status)
      .subscribe(
        (res) => {
          switch (status) {
            case 'PENDING': {
              this.pendingValue = res.totalValue;
              this.pendingQuantity = res.quantity;
              break;
            }
            case 'CANCELED': {
              this.canceledValue = res.totalValue; 
              this.canceledQuantity = res.quantity;
              break;
            }
            case 'COMPENSATED': {
              this.compensatedValue = res.totalValue;
              this.compensatedQuantity = res.quantity;
              break;
            }

          }
          
          // atualiza o front da tabela
          // this.setArrayForShowReceipts(true);
          // this.calcPaginationReceipts();
        },
        (err) => console.error(err),
        () => this.cdr.detectChanges()
      );
  }

  // setArrayForShowReceipts(arg0: boolean) {
  //   throw new Error('Method not implemented.');
  // }

  // calcPaginationReceipts() {
  //   throw new Error('Method not implemented.');
  // }

  private getBilletsByUuid(uuidAccountPayment: string) {
    this.loadingService.show();
    this.billetService.getBilletsByUuid(uuidAccountPayment)
     .subscribe(
        (res) => {
          this.loadingService.hide();
         // console.log(res) // Criar variavel para armazenar o retorno. com nome de dataLotReturn.     
          this.toggleSpinnerUpdate = false
        },
        (err) => {
          console.error(err);
          this.loadingService.hide();
        },
        () => {
          this.loadingService.hide();
        }
    );
    this.cdr.detectChanges();
  }

  showQuantity(quantity: any) {
    const param = {
      amount: quantity > 0 ? quantity : 0,
    };
    return param;
  }

  updateTable() {
    this.toggleSpinnerUpdate = true;
    setTimeout(() => {
      this.getBilletsByUuid(this.userProfile.uuidAccount);
    }, 1000);
  }

  delete() {
    let selectedData = this.billets.filter(source => source.isItemChecked === false);
    this.billets = selectedData;
    this.indeterminateState = false;
    this.allPendingItems = 0
  }
  // paginateArray() {
  //   this.page++;
  //   return this.data.filter(
  //     x => x.id > (this.page * this.perPage - this.perPage) && x.id <= (this.page * this.perPage)
  //   );
  // }
  // loadMore(event) {
  //   setTimeout(() => {
  //     // const array = this.paginateArray();
  //     console.log('new data: ', array);
  //     this.billets = this.billets.concat(array);
  //     console.log('list data: ', this.billets);
  //     event.target.complete();
  //   }, 1000);
  // }

  openMoreActionMenu(i) {
    let newMoreActionsMenu = {
      index: i,
      isOpen: !this.moreActionsMenuIsOpen.isOpen
    }

    this.moreActionsMenuIsOpen = newMoreActionsMenu
  }

  statusColor(status) {
    switch (status) {
      case 'PENDING': {
        return 'text-pending'
      }
      case 'COMPENSATED': {
        return 'text-compensated';
      }
      case 'CANCELED': {
        return 'text-canceled';
      }
      case 'PROCESSING': {
        return 'text-processing';
      }
    }
  }

  statusLabel(status) {
    switch (status) {
      case 'PENDING': {
        return this.translate.applyTranslate('CASH_OUT.BILLET_VIEW_DETAIL.TABLE.STATUS.PENDING');
      }
      case 'CANCELED': {
        return this.translate.applyTranslate('CASH_OUT.BILLET_VIEW_DETAIL.TABLE.STATUS.CANCELED');
      }
      case 'COMPENSATED': {
        return this.translate.applyTranslate('CASH_OUT.BILLET_VIEW_DETAIL.TABLE.STATUS.COMPENSATED');
      }
      case 'PROCESSING': {
        return this.translate.applyTranslate('CASH_OUT.BILLET_VIEW_DETAIL.TABLE.STATUS.PROCESSING');
      }
    }

  }

  checkCheckbox() {
    setTimeout(() => {
      this.billets.forEach(item => {
        if (item.status == "PENDING") {
          item.isItemChecked = this.checkParent
        }
      });
    });
  }

  verifyEvent() {
    let selected = 0;
    this.allPendingItems = 0

    this.billets.map(item => {
      if (item.status == "PENDING") {
        this.allPendingItems++;
        if (item.isItemChecked) selected++;
      }
    });


    if (selected > 0 && selected < this.allPendingItems) {
      // One item is selected among all checkbox elements
      this.indeterminateState = true;
      this.checkParent = false;
    } else if (selected == this.allPendingItems) {
      // All item selected
      this.indeterminateState = false;
      this.checkParent = true;
    } else {
      // No item is selected
      this.indeterminateState = false;
      this.checkParent = false;
    }
  }

  goToEditPage(editType: number, uuidBilletSelected: any) {
    let goBackRoute = ""
    this.route.url.subscribe(route => {
      goBackRoute = route[0].path
    })

    const resetMoreActionsMenu = {
      index: null,
      isOpen: false
    }

    this.moreActionsMenuIsOpen = resetMoreActionsMenu

    const urlTarget = `/app/charging/billet/${goBackRoute}`;
    //console.log('urlTarget: ', urlTarget)
    this.navCtrl.navigateRoot(["/app/charging/billet/edit"], {
      queryParams: { 
        goBackRoute: urlTarget,
        editType: editType,
        uuidBillet: uuidBilletSelected
      }
    })
  }

  goBack() {
    this.navCtrl.navigateRoot("/app/dashboard");
  }

  public deleteBillet(billetIndex: number) {
    let arrayFiltered = []

    arrayFiltered = this.billets.filter(item => {
      return item.id != billetIndex;
    })

    this.billets = arrayFiltered;
    this.statusNotification('success', 'FAVORITES.MESSAGES.DELETE_SUCCESS', true)
  }

  public async viewDetail() {
    const modalToken = await this.modalController.create({
      component: ModalBilletViewDetailComponent,
      cssClass: 'modal-view-detail',
      componentProps: {
        validationOnly: true,
        codeOperation: this.OPERATION,
        confirmation: true
      },
      backdropDismiss: false,
    });
    return await modalToken.present();
  }

  public async cancelAlert(uuidBillet?: string) {
    const modalToken = await this.modalController.create({
      component: ModalBilletAlertCancelComponent,
      cssClass: 'modal-billet-alert-cancel',
      componentProps: {
        validationOnly: true,
        codeOperation: this.OPERATION,
        confirmation: true,
        confirm: () => this.validateToken(uuidBillet),
        title: 'CASH_OUT.MODAL_CANCEL.TITLE',
        description: 'CASH_OUT.MODAL_CANCEL.DESCRIPTION',
        alert1: 'CASH_OUT.MODAL_CANCEL.ALERT1',
        alert2: 'CASH_OUT.MODAL_CANCEL.ALERT2',
        confirmBtn: 'CASH_OUT.MODAL_CANCEL.BUTTON1',
        cancelBtn: 'CASH_OUT.MODAL_CANCEL.BUTTON2'
      },
      backdropDismiss: false,
    });
    return await modalToken.present();
  }

  public async validateToken(uuidBillet?: string) {
    const modalToken = await this.modalController.create({
      component: ModalTokenComponent,
      cssClass: 'modal-token',
      componentProps: {
        validationOnly: true,
        codeOperation: this.OPERATION,
        confirmation: true,
      },
      backdropDismiss: false,
    });
    modalToken.onDidDismiss().then((data) => {
      const codeAuthorization = data.role
    });
    return await modalToken.present();
  }

  private async statusNotification(status: string, message: string, translateFlag: boolean) {
    this.loadingService.hide();
    const translate = translateFlag ? true : false;
    const modalStatus = await this.modalController.create({
      component: ModalAlertComponent,
      cssClass: 'modal-alert-class',
      componentProps: {
        status: status,
        message: 'CASH_OUT.MODAL_ALERT.ALERT1',
        confirmBtn: 'CASH_OUT.ACCOUNT_CHARGING.CLOSE_BUTTON',
        translate: translate,
      },
      backdropDismiss: false,
    });
    return await modalStatus.present();
  }

  public async manualCheckout() {
    const modalManualCheckout = await this.modalController.create({
      component: ModalBilletAlertCancelComponent,
      cssClass: 'modal-billet-alert-cancel',
      componentProps: {
        validationOnly: true,
        codeOperation: this.OPERATION,
        confirmation: true,
        confirm: () => this.validateTokenManualCheckout(),
        title: 'CASH_OUT.MODAL_MANUAL_CHECKOUT.TITLE',
        description: 'CASH_OUT.MODAL_MANUAL_CHECKOUT.DESCRIPTION',
        alert1: 'CASH_OUT.MODAL_MANUAL_CHECKOUT.ALERT1',
        alert2: 'CASH_OUT.MODAL_MANUAL_CHECKOUT.ALERT2',
        confirmBtn: 'CASH_OUT.MODAL_MANUAL_CHECKOUT.BUTTON1',
        cancelBtn: 'CASH_OUT.MODAL_MANUAL_CHECKOUT.BUTTON2'
      },
      backdropDismiss: false,
    });
    return await modalManualCheckout.present();
  }

  public async validateTokenManualCheckout() {
    const modalTokenManualCheckout = await this.modalController.create({
      component: ModalTokenComponent,
      cssClass: 'modal-token',
      componentProps: {
        validationOnly: false,
        codeOperation: this.OPERATION,
        confirmation: true,
        onSuccessValidation: () => this.billetManualCheckout()
      },
      backdropDismiss: false,
    });
    return await modalTokenManualCheckout.present();
  }

  public billetManualCheckout() {
    this.statusNotificationManualCheckout('success', 'CASH_OUT.MODAL_ALERT.ALERT3', true)
  }

  private async statusNotificationManualCheckout(status: string, message: string, translateFlag: boolean) {
    this.loadingService.hide();
    const translate = translateFlag ? true : false;
    const modalStatus = await this.modalController.create({
      component: ModalAlertComponent,
      cssClass: 'modal-alert-class',
      componentProps: {
        status: status,
        message: 'CASH_OUT.MODAL_ALERT.ALERT3',
        confirmBtn: 'CASH_OUT.ACCOUNT_CHARGING.CLOSE_BUTTON',
        translate: translate,
      },
      backdropDismiss: false,
    });
    return await modalStatus.present();
  }
}
